import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MyProfileTab } from "./tabs/MyProfileTab";
import { MyCompanyTab } from "./tabs/MyCompanyTab";

interface TabbedProfileProps {
  initialData: any;
}

export const TabbedProfile = ({ initialData }: TabbedProfileProps) => {
  return (
    <Tabs defaultValue="profile" className="w-full">
      <TabsList className="grid w-full grid-cols-2 mb-6 bg-muted p-1 rounded-lg h-12">
        <TabsTrigger 
          value="profile" 
          className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground text-muted-foreground rounded-md font-medium transition-all data-[state=active]:shadow-sm"
        >
          My Profile
        </TabsTrigger>
        <TabsTrigger 
          value="company" 
          className="data-[state=active]:bg-secondary data-[state=active]:text-secondary-foreground text-muted-foreground rounded-md font-medium transition-all data-[state=active]:shadow-sm"
        >
          My Company
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="profile" className="mt-0 border-t-2 border-primary/20 pt-6">
        <MyProfileTab initialData={initialData} />
      </TabsContent>
      
      <TabsContent value="company" className="mt-0 border-t-2 border-secondary/20 pt-6">
        <MyCompanyTab initialData={initialData} />
      </TabsContent>
    </Tabs>
  );
};